module.exports = __webpack_public_path__ + "static/media/logo_glo1.ad085952.svg";